export const DESKTOP_REDIRECT_ENABLED = true

export const isMobileDevice = () => {
    // Проверка через User Agent
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    // Паттерны для мобильных устройств
    const mobilePatterns = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
        /Opera Mini/i,
        /IEMobile/i,
        /Mobile/i,
        /mobile/i,
        /CriOS/i, // Chrome on iOS
        /FxiOS/i, // Firefox on iOS
        /Tablet/i,
    ]

    const isMobileUA = mobilePatterns.some((pattern) => pattern.test(userAgent))

    // Дополнительная проверка через touch events
    const hasTouchScreen =
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0

    // Проверка через размер экрана (мобильные обычно < 768px)
    const isSmallScreen = window.innerWidth <= 768

    // Проверка через Telegram WebApp если доступно
    const tg = window.Telegram?.WebApp
    if (tg && tg.platform) {
        const telegramPlatform = tg.platform.toLowerCase()
        const mobilePlatforms = ['ios', 'android', 'android_x']
        return mobilePlatforms.includes(telegramPlatform)
    }

    // Комбинированная проверка: UA + (touch ИЛИ маленький экран)
    return isMobileUA || (hasTouchScreen && isSmallScreen)
}

/**
 * Определяет, является ли устройство десктопом
 */
export const isDesktopDevice = () => {
    return !isMobileDevice()
}

/**
 * Получает детальную информацию о платформе
 */
export const getPlatformInfo = () => {
    const userAgent = navigator.userAgent || ''
    const tg = window.Telegram?.WebApp

    let platform = 'unknown'
    let isMobile = false
    let source = 'user-agent'

    // Приоритет: Telegram WebApp API
    if (tg && tg.platform) {
        platform = tg.platform.toLowerCase()
        source = 'telegram'
        isMobile = ['ios', 'android', 'android_x'].includes(platform)
    } else {
        // Fallback на User Agent
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
            platform = 'ios'
            isMobile = true
        } else if (/Android/i.test(userAgent)) {
            platform = 'android'
            isMobile = true
        } else if (/Windows/i.test(userAgent)) {
            platform = 'windows'
            isMobile = false
        } else if (/Macintosh|Mac OS/i.test(userAgent)) {
            platform = 'macos'
            isMobile = false
        } else if (/Linux/i.test(userAgent)) {
            platform = 'linux'
            isMobile = false
        }
    }

    return {
        platform,
        isMobile,
        isDesktop: !isMobile,
        source,
        hasTouchScreen:
            'ontouchstart' in window || navigator.maxTouchPoints > 0,
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        userAgent: userAgent.substring(0, 100), // Обрезаем для логов
    }
}

/**
 * Проверяет, нужно ли показывать заглушку для десктопа
 */
export const shouldShowDesktopStub = () => {
    if (!DESKTOP_REDIRECT_ENABLED) {
        return false
    }
    return isDesktopDevice()
}
